// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCVx2-RaFYu6HZOJKgr16vCDO9RbIb6JNw",
  authDomain: "form-d85df.firebaseapp.com",
  databaseURL: "https://form-d85df-default-rtdb.firebaseio.com",
  projectId: "form-d85df",
  storageBucket: "form-d85df.firebasestorage.app",
  messagingSenderId: "96604872438",
  appId: "1:96604872438:web:a98e5999174f15d1aad6d7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);
export default app;